export default __webpack_public_path__ + "static/tag-do-2-dark-032771af40bc3f6ddc3fa7e4e367e412bebc360549c33f0c5ffda15593bfca57.png";